import React from 'react';
import FileSaver from 'file-saver';
import { Button } from '@material-ui/core';
import { MposWebPortalApi } from '../../../services/api/MposWebPortalApi';
import { useHistory } from 'react-router-dom';
import './DownloadUsersFile.scss';
//

const DownloadUsersFile: React.FC = ({children}) => {
  const [loading, setLoading] = React.useState(false);
  const history = useHistory()
  
  const handleExport = (): void => {
    setLoading(true);
    MposWebPortalApi.getInstance().downloadUsers().subscribe(({blob, fileName}) => {
        FileSaver.saveAs(blob, fileName);
        setLoading(false);
    }, () => {
        // show error page
        history.push('/result', {
            isSuccess: false,
            errorTitle: "Si è verificato un errore durante il download del file",
            message: "Riprova più tardi. Grazie per la pazienza",
            button: "TORNA ALLE UTENZE",
            data: { from: "Users", operation: "downloadUsers" }
        })
    });
  };

  return (
    <Button
      onClick={handleExport}
      id={"export-users"}
      disabled={loading}
    >
      {children}
    </Button>
  );
};

export default DownloadUsersFile;
